import React, { useState } from 'react'
import { NavLink,useNavigate } from 'react-router-dom'
import './Login.css';
import { auth } from './Firebase';
function Login() {
  const navigate=useNavigate()
  const[email,setemail]=useState('')
const[password,setpassword]=useState('')


  const signIn=(e)=>{
    e.preventDefault();
    //firebase stuff
    auth .signInWithEmailAndPassword(email,password).then((auth)=>{
      console.log(auth)
      if(auth){
        navigate('/')
      }
    }).catch((error)=>{
      alert(error.message)
    })
  }
  const register=(e)=>{
    e.preventDefault();

    //firebase register stuff
    auth
          .createUserWithEmailAndPassword(email,password).then((auth)=>{
            console.log(auth);
            if(auth){
              navigate('/')
            }
          }).catch(error => alert(error.message))
  }
  return (
    <div className='login'>
        <NavLink to='/'>
        <img className='login__image' src='https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png' />
        </NavLink>
        <div className='login__container' >
            <h2>Sign in</h2>
            <form>
            <h6>Email or mobile phone number</h6>
             <input type='email' value={email} onChange={e=>setemail(e.target.value)} />   
            <h6>Password</h6>
             <input type='password' onChange={event => setpassword(event.target.value)} /> 
            <button onClick={signIn} type='submit'>Continue</button>
            </form>
            <p>By continuing, you agree to Amazon's Conditions of Use and Privacy Notice.</p>
            <a>Need help?</a>
            <button onClick={register} className='login__registerButton'>Create your Amazon Account</button>
            </div>

        
    </div>
  )
}

export default Login